import { Box } from '@mui/material';
import { useState } from 'react';

import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';

import { Co2FormTourTravel } from '../Co2FormTourTravel';
import { TourTravelDataForm } from './TourTravelDataForm';

export function TourTravelView({
  tourTravel,
  onDelete,
}: {
  tourTravel: TourTravel;
  onDelete?: () => void;
}) {
  const [keyToUpdateComponent, setKeyToUpdateComponent] = useState(0);

  const onTotalDistanceChange = () => {
    setKeyToUpdateComponent(keyToUpdateComponent + 1);
  };

  return (
    <Box>
      <TourTravelDataForm
        tourTravel={tourTravel}
        onTotalDistanceChange={onTotalDistanceChange}
        onDelete={onDelete}
      />
      <Co2FormTourTravel tourTravel={tourTravel} key={keyToUpdateComponent} />
    </Box>
  );
}
